module.exports = __webpack_public_path__ + "./images/d9cf424c2c0b31ffdf73ed91663e32b7.webp";